import { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Container, Grid, Tab, Tabs } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { ClientCreateOrEditForm } from './components/ClientEditForm';
import { setGuestFields } from '../../../hooks/useGuestFields';
import { useSwaggerClient } from '../../../hooks/useSwaggerClient';
import { parseClient, saveClient } from './clientMapper';
import ClientEditSidebar, { ACTIVE_CLIENT_SIDEBAR_TAB_NAMES } from './ClientEditSidebar';
import { useNotify } from '../../../hooks/useNotify';

function ClientEditPage() {
    const history = useHistory();
    const { clientId } = useParams();

    const { notifySuccess, notifyError } = useNotify();

    const isNew = clientId === 'new';
    const [client, loading, error] = useSwaggerClient(
        'clients',
        isNew ? false : 'getClient', // No client id no call
        {
            clientId
        },
        [],
        ({ client: c }) => parseClient(c)
    );
    const primaryColor = client?.primaryColor;
    const [submitClient, setSubmitClient] = useState(false);

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const { client_key: savedClientKey } = await saveClient(
                isNew ? false : clientId,
                values
            );
            if (window.ACTIVITER_CLIENT === savedClientKey) {
                setGuestFields(values.guest_fields, values.header_guest_fields);
            }
            setSubmitClient(true);
            setSubmitting(false);
            history.push('/admin/client/list');
            notifySuccess(`Client ${isNew ? 'created' : 'updated'} successfully!`);
        } catch (err) {
            console.error(err);
            setSubmitting(false);
            notifyError(`Error during client ${isNew ? 'creation' : 'updating'}!`);
        }
    };

    if (loading && !isNew) {
        return null;
    }

    if (error) {
        return <p>{error.response.body.message}</p>;
    }

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                {!isNew ? (
                    <ClientEditSidebar
                        clientId={clientId}
                        activeTab={ACTIVE_CLIENT_SIDEBAR_TAB_NAMES.client}
                    />
                ) : (
                    <Tabs orientation="vertical" variant="scrollable" value={0}>
                        <Tab
                            label="Client"
                            component={Link}
                            to={`/admin/client/${isNew ? 'new' : clientId}/`}
                        />
                    </Tabs>
                )}
                <Grid className="pageContent">
                    <ClientCreateOrEditForm
                        clientId={clientId}
                        initialValues={client || parseClient({})}
                        primaryColor={primaryColor}
                        onSubmit={handleSubmit}
                        editMode={clientId !== 'new'}
                        submitClient={submitClient}
                    />
                </Grid>
            </Grid>
        </Container>
    );
}

export default ClientEditPage;
